import { TmBaseError } from '@/core/error/tmBaseError'

export class TmScriptLoadError<T extends Record<string, unknown>> extends TmBaseError<T> {
  public name = 'TmScriptLoadError'

  constructor(msg: string, data?: T, stack?: string) {
    super(msg, data, stack)
    this.isMonitored = false
  }
}
